export default __webpack_public_path__ + "static/logo-white-5a102729f560ae0aac47f005b14abb32.png";